/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BREEDER v2 API
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  JobDetail,
  JobSummary,
  JobsListJobsParams
} from '../model';

import { apiFetch } from '../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getJobsListJobsUrl = (params?: JobsListJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/jobs?${stringifiedParams}` : `/api/v1/jobs`
}

/**
 * @summary Background jobs (own, or everybody's; optionally only queued/running ones)
 */
export const jobsListJobs = async (params?: JobsListJobsParams, options?: Parameters<typeof apiFetch>[1]): Promise<JobSummary[]> => {

  return apiFetch<JobSummary[]>(getJobsListJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobsListJobsQueryKey = (params?: JobsListJobsParams,) => {
    return [
    `/api/v1/jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getJobsListJobsQueryOptions = <TData = Awaited<ReturnType<typeof jobsListJobs>>, TError = HTTPValidationError>(params?: JobsListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobsListJobs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobsListJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobsListJobs>>> = ({ signal }) => jobsListJobs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobsListJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobsListJobsQueryResult = NonNullable<Awaited<ReturnType<typeof jobsListJobs>>>
export type JobsListJobsQueryError = HTTPValidationError


export function useJobsListJobs<TData = Awaited<ReturnType<typeof jobsListJobs>>, TError = HTTPValidationError>(
 params: undefined |  JobsListJobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobsListJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobsListJobs>>,
          TError,
          Awaited<ReturnType<typeof jobsListJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobsListJobs<TData = Awaited<ReturnType<typeof jobsListJobs>>, TError = HTTPValidationError>(
 params?: JobsListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobsListJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobsListJobs>>,
          TError,
          Awaited<ReturnType<typeof jobsListJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobsListJobs<TData = Awaited<ReturnType<typeof jobsListJobs>>, TError = HTTPValidationError>(
 params?: JobsListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobsListJobs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Background jobs (own, or everybody's; optionally only queued/running ones)
 */

export function useJobsListJobs<TData = Awaited<ReturnType<typeof jobsListJobs>>, TError = HTTPValidationError>(
 params?: JobsListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobsListJobs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobsListJobsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobsJobUrl = (jobId: string,) => {




  return `/api/v1/jobs/${jobId}`
}

/**
 * @summary One job with its log
 */
export const jobsJob = async (jobId: string, options?: Parameters<typeof apiFetch>[1]): Promise<JobDetail> => {

  return apiFetch<JobDetail>(getJobsJobUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobsJobQueryKey = (jobId: string,) => {
    return [
    `/api/v1/jobs/${jobId}`
    ] as const;
    }


export const getJobsJobQueryOptions = <TData = Awaited<ReturnType<typeof jobsJob>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobsJob>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobsJobQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobsJob>>> = ({ signal }) => jobsJob(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobsJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobsJobQueryResult = NonNullable<Awaited<ReturnType<typeof jobsJob>>>
export type JobsJobQueryError = HTTPValidationError


export function useJobsJob<TData = Awaited<ReturnType<typeof jobsJob>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobsJob>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobsJob>>,
          TError,
          Awaited<ReturnType<typeof jobsJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobsJob<TData = Awaited<ReturnType<typeof jobsJob>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobsJob>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobsJob>>,
          TError,
          Awaited<ReturnType<typeof jobsJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobsJob<TData = Awaited<ReturnType<typeof jobsJob>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobsJob>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One job with its log
 */

export function useJobsJob<TData = Awaited<ReturnType<typeof jobsJob>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobsJob>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobsJobQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobsCancelJobUrl = (jobId: string,) => {




  return `/api/v1/jobs/${jobId}/cancel`
}

/**
 * @summary Ask a running job to stop (its owner or an administrator)
 */
export const jobsCancelJob = async (jobId: string, options?: Parameters<typeof apiFetch>[1]): Promise<JobDetail> => {

  return apiFetch<JobDetail>(getJobsCancelJobUrl(jobId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getJobsCancelJobMutationKey = () => ['jobsCancelJob'] as const;

export const getJobsCancelJobMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobsCancelJob>>, TError,JobsCancelJobMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof jobsCancelJob>>, TError,JobsCancelJobMutationVariables, TContext> => {

const mutationKey = getJobsCancelJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobsCancelJob>>, JobsCancelJobMutationVariables> = (props) => {
          const {jobId} = props ?? {};

          return  jobsCancelJob(jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobsCancelJobMutationResult = NonNullable<Awaited<ReturnType<typeof jobsCancelJob>>>

    export type JobsCancelJobMutationError = HTTPValidationError
    export type JobsCancelJobMutationVariables = {jobId: string}

    /**
 * @summary Ask a running job to stop (its owner or an administrator)
 */
export const useJobsCancelJob = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobsCancelJob>>, TError,JobsCancelJobMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobsCancelJob>>,
        TError,
        JobsCancelJobMutationVariables,
        TContext
      > => {
      return useMutation(getJobsCancelJobMutationOptions(options), queryClient);
    }
    export const getJobsJobFileUrl = (jobId: string,) => {




  return `/api/v1/jobs/${jobId}/file`
}

/**
 * @summary Download the job's result file (its owner or an administrator)
 */
export const jobsJobFile = async (jobId: string, options?: Parameters<typeof apiFetch>[1]): Promise<Blob> => {

  return apiFetch<Blob>(getJobsJobFileUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobsJobFileQueryKey = (jobId: string,) => {
    return [
    `/api/v1/jobs/${jobId}/file`
    ] as const;
    }


export const getJobsJobFileQueryOptions = <TData = Awaited<ReturnType<typeof jobsJobFile>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobsJobFile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobsJobFileQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobsJobFile>>> = ({ signal }) => jobsJobFile(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobsJobFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobsJobFileQueryResult = NonNullable<Awaited<ReturnType<typeof jobsJobFile>>>
export type JobsJobFileQueryError = HTTPValidationError


export function useJobsJobFile<TData = Awaited<ReturnType<typeof jobsJobFile>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobsJobFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobsJobFile>>,
          TError,
          Awaited<ReturnType<typeof jobsJobFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobsJobFile<TData = Awaited<ReturnType<typeof jobsJobFile>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobsJobFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobsJobFile>>,
          TError,
          Awaited<ReturnType<typeof jobsJobFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobsJobFile<TData = Awaited<ReturnType<typeof jobsJobFile>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobsJobFile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the job's result file (its owner or an administrator)
 */

export function useJobsJobFile<TData = Awaited<ReturnType<typeof jobsJobFile>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobsJobFile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobsJobFileQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobsRetryJobUrl = (jobId: string,) => {




  return `/api/v1/jobs/${jobId}/retry`
}

/**
 * @summary Run a failed or cancelled job again with the same input
 */
export const jobsRetryJob = async (jobId: string, options?: Parameters<typeof apiFetch>[1]): Promise<JobSummary> => {

  return apiFetch<JobSummary>(getJobsRetryJobUrl(jobId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getJobsRetryJobMutationKey = () => ['jobsRetryJob'] as const;

export const getJobsRetryJobMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobsRetryJob>>, TError,JobsRetryJobMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof jobsRetryJob>>, TError,JobsRetryJobMutationVariables, TContext> => {

const mutationKey = getJobsRetryJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobsRetryJob>>, JobsRetryJobMutationVariables> = (props) => {
          const {jobId} = props ?? {};

          return  jobsRetryJob(jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobsRetryJobMutationResult = NonNullable<Awaited<ReturnType<typeof jobsRetryJob>>>

    export type JobsRetryJobMutationError = HTTPValidationError
    export type JobsRetryJobMutationVariables = {jobId: string}

    /**
 * @summary Run a failed or cancelled job again with the same input
 */
export const useJobsRetryJob = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobsRetryJob>>, TError,JobsRetryJobMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobsRetryJob>>,
        TError,
        JobsRetryJobMutationVariables,
        TContext
      > => {
      return useMutation(getJobsRetryJobMutationOptions(options), queryClient);
    }
